export const setAmplitudeUser = (data) => {
    try {
        amplitude.getInstance().setUserId(data.id);
        amplitude.getInstance().setUserProperties({
            country: data.country,
            projects_count: data.projects,
            email_verified: data.email_verified,
            subscriptions_count: data.subscriptions?.length || 0,
        });
    } catch {}
}

export const setAmplitudePageView = (routeTo, routeFrom = null) => {
    try {
        amplitude.getInstance().logEvent("pageview", {
            url: routeTo.path,
            full_url: routeTo.fullPath,
            from_url: routeFrom.path,
            from_full_url: routeFrom.fullPath
        });
    } catch {}
}

export const setAmplitudeEvent = (event, params = {}) => {
    try {
        amplitude.getInstance().logEvent(event, params);
    } catch {}
}

export const setAmplitudeRevenue = (productId, price, quantity = 1) => {
    try {
        const revenue = new amplitude.Revenue().setProductId(productId).setPrice(price).setQuantity(quantity);
        amplitude.getInstance().logRevenueV2(revenue);
    } catch {}
}
